import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { AccountClient, MemberDto, AccountResponseDto } from '../api/api-client';

/**
 * Hook to get account members list
 */
export const useAccountMembers = () => {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: ['account', 'members'],
    queryFn: async (): Promise<MemberDto[]> => {
      const client = new AccountClient();
      return await client.getMembers();
    },
    enabled: isAuthenticated,
  });
};

/**
 * Hook to get account settings/info
 */
export const useAccount = () => {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: ['account'],
    queryFn: async (): Promise<AccountResponseDto> => {
      const client = new AccountClient();
      return await client.getAccount();
    },
    enabled: isAuthenticated,
  });
};